<template>
    <div>
        <!-- Start Footer Area  -->
        <footer v-if="data.showFooter" class="rn-footer footer-style-default variation-two">
            <div class="footer-top d-none d-lg-block">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-2 col-md-6 col-sm-6 col-12 pl-lyd-20" style="margin-right: 1%;">
                            <div class="rn-footer-widget">
                                <div class="widget-menu-top">
                                    <h4 class="title">平台</h4>
                                    <div class="inner">
                                        <ul class="footer-link link-hover">
                                            <li>
                                                <router-link to="/ai-page">元生AI平台</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/home">BossinMind 博信诚一站式AI大模型</router-link>
                                            </li>
                                            <li>
                                                <router-link to="/ecop-page">智慧创新平台ECOP</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-2 col-md-6 col-sm-6 col-12">
                            <div class="rn-footer-widget">
                                <h4 class="title">产品及解决方案</h4>
                                <div class="inner ">
                                    <ul class="footer-link link-hover">
                                        <li>
                                            <router-link to="/product-solution/1">BossinData数据智能体平台</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product-solution/2">智审通 | AI审核平台</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product-solution/3">AI智慧网银</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product-solution/4">EECloud大企业业财一体化AI</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-2 col-md-6 col-sm-6 col-12" style="margin-right: 3%;">
                            <div class="rn-footer-widget">
                                <h4 class="title"></h4>
                                <div class="inner">
                                    <ul class="footer-link link-hover">
                                        <li>
                                            <router-link to="/product-solution/5">医鉴通 | 医嘱与病历审核质控智能体</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product-solution/6">医院AI审核</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/product-solution/7">医院收入运营数据智能体</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1 col-md-6 col-sm-6 col-12" style="margin-right: 2%;">
                            <div class="rn-footer-widget">
                                <h4 class="title">行业实践</h4>
                                <div class="inner">
                                    <ul class="footer-link link-hover">
                                        <li>
                                            <router-link to="/industry-practice/1">医疗行业</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/industry-practice/0">央国企</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-1 col-md-6 col-sm-6 col-12" style="margin-right: 2%;">
                            <div class="rn-footer-widget">
                                <h4 class="title">关于我们</h4>
                                <div class="inner">
                                    <ul class="footer-link link-hover">
                                        <li>
                                            <router-link to="/about-us?id=1">公司介绍</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=2">荣誉资质</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=3">服务支持</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=4">加入我们</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/about-us?id=5">新闻动态</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
                            <div class="rn-footer-widget lastLi">
                                <h4 class="title">关注或联系我们</h4>
                                <div class="inner">
                                    <ul class="footer-link link-hover">
                                        <li>
                                             <a >咨询热线：010-84466910</a>
                                        </li>
                                        <li>
                                             <a >企业邮箱：Company@Bossint.com.cn</a>
                                        </li>
                                        <li>
                                             <a >北京总部：北京市东城区银河SOHO商厦B座</a>
                                        </li>
                                        <li>
                                             <a >研发基地：北京市朝阳区浙江大厦</a>
                                        </li>
                                        <li class="d-flex align-items-center gap-4 qrcodeDiv">
                                            <div class="qrItem">
                                                <img src="@/assets/newImages/weixin.png" alt="">
                                                <div class="text-center qc-title">微信公众号</div>
                                            </div>
                                            <div class="qrItem">
                                                <img src="@/assets/newImages/douyin.png" alt="">
                                                <div class="text-center qc-title">抖音号</div>

                                            </div>
                                            <div class="qrItem">
                                                <img src="@/assets/newImages/kuaishou.png" alt="">
                                                <div class="text-center qc-title">快手号</div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
					</div>
                </div>
            </div>
        </footer>

        <Copyright v-if="data.showCopyright"/>
        <div class="order-show" v-if="shows">
            <order-show @close="close"></order-show>
        </div>
        <!-- <ScrollTop class="d-none d-lg-block"></ScrollTop>
        <ScrollTop2 class="d-none d-lg-block"></ScrollTop2> -->
        <div class=" d-none d-lg-block">
            <div class="scroll-robot">
                <img src="@/assets/newImages/机器人_icon.png" alt="">
            </div>
            <div class="scroll-top">
                <div class="chevron-bar-up" @click="scrollToTop">
                    <div class="img-icon"></div>
                    <!-- <i class="bi bi-chevron-bar-up" style="font-size: 20px;"></i> -->
                </div>
                <div class="telephone">
                    <div class="img-icon"></div>
                    <!-- <i class="bi bi-telephone" style="font-size: 20px;"></i> -->
                    <div class="telephone-card">
                        <div class="fs-4 telephone-card-title">咨询热线</div>
                        <div class="fs-2 telephone-card-phone">186 0092 4570</div>
                    </div>
                </div>
                <div class="qr-code-scan">
                    <div class="img-icon"></div>
                    <!-- <i class="bi bi-qr-code-scan" style="font-size: 20px;"></i> -->
                    <div class="qr-code-card qrcodeDiv">
                        <div class="qrItem">
                            <img src="@/assets/newImages/weixin.png" alt="">
                            <div class="text-center qc-title">微信公众号</div>
                        </div>
                        <div class="qrItem">
                            <img src="@/assets/newImages/douyin.png" alt="">
                            <div class="text-center qc-title">抖音号</div>
    
                        </div>
                        <div class="qrItem">
                            <img src="@/assets/newImages/kuaishou.png" alt="">
                            <div class="text-center qc-title">快手号</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
.order-show {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: rgba($color: #999, $alpha: 0.9);
}
.scroll-robot{
    position: fixed;
    bottom: 200px;
    right: 15px;
    z-index: 99;
    img{
        width: 80px;
    }
}
.scroll-top{
    position: fixed;
    bottom: 30px;
    right: 30px;
    text-align: center;
    z-index: 99;
    border-radius: 6px;
    box-shadow: 0 0 18px 0 #005bab1f;
    width: 50px;
    height: 150px;
    background: #fff;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-around;
    color: #0E111B;
    .chevron-bar-up .img-icon{
        background-image: url('../../../assets/newImages/srollTop/置顶_icon.png');
        &:hover{
            background-image: url('../../../assets/newImages/srollTop/置顶_icon_blue.png');
        }
    }
    .telephone .img-icon{
        background-image: url('../../../assets/newImages/srollTop/电话_icon.png');
        &:hover{
            background-image: url('../../../assets/newImages/srollTop/电话_icon_blue.png');
        }
    }
    .qr-code-scan .img-icon{
        background-image: url('../../../assets/newImages/srollTop/二维码_icon.png');
        &:hover{
            background-image: url('../../../assets/newImages/srollTop/二维码_icon_blue.png');
        }
    }
    .chevron-bar-up,
    .telephone,
    .qr-code-scan{
        cursor: pointer;
        margin: 0 auto;
        .img-icon{
            width: 20px;
            height: 20px;
            background-size: cover;
            background-position: center;
        }
        &:hover{
            color: #005BAB;
        }
    }
}
.telephone{
    .telephone-card{
        display: none;
    }
    &:hover{
        .telephone-card{
            display: block;
            position: fixed;
            bottom: 60px;
            right: 100px;
            z-index: 100;
            width: 312px;
            height: 90px;
            padding:20px;
            border-radius: 6px;
            background: #F9FCFE;
            box-shadow: 0 0 24px 0 #c6d9fe8a;
            background-image: url('../../../assets/newImages/srollTop/scrollTop_bg2.png');
            background-size: cover;
            background-position: center;
            text-align: left;
            .telephone-card-title{
                color: #697C99;
            }
            .telephone-card-phone{
                color: #091E3E;
                font-weight: 700;
            }
            
        }
    }
}
.qr-code-scan{
    .qr-code-card{
        display: none;
            
    }
    &:hover{
        .qr-code-card{
            display: block;
            position: fixed;
            bottom: 30px;
            right: 100px;
            z-index: 100;
            width: 312px;
            height: 150px;
            padding:0 20px;
            border-radius: 6px;
            background: #F9FCFE;
            box-shadow: 0 0 24px 0 #c6d9fe8a;
            background-image: url('../../../assets/newImages/srollTop/scrollTop_bg.png');
            background-size: cover;
            background-position: center;
            display: flex;
            justify-content: space-around;
            align-items: center;
            img{
                width: 80px;
                height: 80px;
            }
        }
    }
}
</style>
<script>
    import Copyright from './Copyright'
    import Button from '../../elements/button/Button'
    import Icon from '../../icon/Icon'
    import ScrollTop from './ScrollTop'
    import ScrollTop2 from './ScrollTop2'
    import Logo from '../../elements/logo/Logo'
    import Newsletter from './Newsletter'
    import OrderShow from '../dialog/orderShow.vue'

    export default {
        name: 'Footer',
        components: {Newsletter, Logo, ScrollTop, ScrollTop2, Icon, Button, Copyright, OrderShow},
        props: {
            data: {
                default: null,
            }
        },
        data(){
            return {
                shows: false,
            }
        },
        mounted(){
            
            if (this.$route.query.aaa) {
                this.shows = true
            }
        },
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            },
            toCall(){
                this.$router.push({
                    path: '/call-us'
                })
            },
            orderShow() {
                this.shows = true
            },
            close(){
                this.shows = false
                
            },
            goRouter(val){
                if (this.$route.path !== '/about-us') {
                    sessionStorage.setItem('a-id',val)
                    this.$router.push({
                        path: '/about-us'
                    })
                }
            },
            goECOP(val){
                if (this.$route.path !== '/platform') {
                    sessionStorage.setItem('a-id',val)
                this.$router.push({
                    path: '/platform'
                })
                }
                
            },
        },
    }
</script>